<template>
  <v-container fluid>
    <v-form ref="form" v-model="form" @submit.prevent="submit">
      <v-row>
        <v-row v-for="(service, index) in hotelServices" :key="'service-' + index">
          <v-col cols="12" class="pb-0">
            <span class="text-h6">Hotel Service: #{{ index + 1 }}</span>
            <v-btn color="red" icon @click="removeHotelServiceEntry(index, service.id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-if="!operation.is_draft">
            <v-switch
              dense
              hide-details
              v-model="service.metadata.arrange_by_owner"
              label="Arrange By Principal?"
              class="mt-0 pt-0"
            ></v-switch>
          </v-col>
          <v-col cols="12" class="pb-0" v-show="!service.metadata.arrange_by_owner">
            <v-row align="center">
              <v-col cols="auto">
                <v-checkbox
                  v-model="service.metadata.singleSharing"
                  label="Single Sharing"
                  class="mt-0"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-text-field
                  v-if="service.metadata.singleSharing"
                  class="ml-8"
                  label="No. Of Crews for Single Sharing"
                  placeholder="Enter No. Of Crews for Single Sharing"
                  :rules="[rules.negative]"
                  outlined
                  hide-details
                  dense
                  type="number"
                  v-model="service.metadata.no_of_single_sharing_crews"
                  prepend-inner-icon="mdi-account"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pb-0" v-show="!service.metadata.arrange_by_owner">
            <v-row align="center">
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0"
                  v-model="service.metadata.doubleSharing"
                  label="Double Sharing"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-text-field
                  v-if="service.metadata.doubleSharing"
                  class="ml-6"
                  label="No. Of Crews for Double Sharing"
                  placeholder="Enter No. Of Crews for Double Sharing"
                  :rules="[rules.negative]"
                  outlined
                  hide-details
                  dense
                  type="number"
                  v-model="service.metadata.no_of_double_sharing_crews"
                  prepend-inner-icon="mdi-account"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pb-0" v-show="!service.metadata.arrange_by_owner">
            <v-row align="center">
              <v-col cols="auto">
                <v-checkbox
                  v-model="service.metadata.tripleSharing"
                  label="Triple Sharing"
                  class="mt-0"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-text-field
                  v-if="service.metadata.tripleSharing"
                  class="ml-9"
                  label="No. Of Crews for Triple Sharing"
                  placeholder="Enter No. Of Crews for Triple Sharing"
                  :rules="[rules.negative]"
                  outlined
                  hide-details
                  dense
                  type="number"
                  v-model="service.metadata.no_of_triple_sharing_crews"
                  prepend-inner-icon="mdi-account"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pb-0 mb-5" v-show="!service.metadata.arrange_by_owner">
            <v-row align="center">
              <v-col cols="auto">
                <v-checkbox
                  v-model="service.metadata.onlyMeal"
                  label="Only Meal"
                  class="mt-0"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-text-field
                  v-if="service.metadata.onlyMeal"
                  class="ml-6"
                  label="No. Of Crews for Only Meal"
                  placeholder="Enter No. Of Crews for Only Meal"
                  :rules="[rules.negative]"
                  outlined
                  hide-details
                  dense
                  type="number"
                  v-model="service.metadata.no_of_only_meal_crews"
                  prepend-inner-icon="mdi-account"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!service.metadata.arrange_by_owner">
            <v-text-field
              label="Total No. Of Nights"
              placeholder="Enter Total No. Of Nights"
              :rules="[rules.negative]"
              outlined
              dense
              type="number"
              v-model="service.metadata.no_of_nights"
              prepend-inner-icon="mdi-home"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!service.metadata.arrange_by_owner">
            <v-select
              label="Day / Half Day Use"
              placeholder="Select Day / Half Day Use"
              outlined
              dense
              v-model="service.metadata.day_or_halfday_use"
              prepend-inner-icon="mdi-calendar-today"
              :items="dayorhalf"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!service.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
            <v-text-field
              label="Service Charges"
              placeholder="Enter Service Charges"
              :rules="amountRules[index]"
              outlined
              dense
              type="number"
              v-model="service.amount"
              prepend-inner-icon="mdi-currency-usd"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!service.metadata.arrange_by_owner">
            <v-select
              label="Supplier"
              placeholder="Select Supplier"
              outlined
              dense
              v-model="service.card_id"
              prepend-inner-icon="mdi-account"
              :items="hotelBookingSuppliers"
              :rules="supplierRules[index]"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!service.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
            <v-select
              label="Tax"
              placeholder="Select Tax"
              outlined
              dense
              v-model="service.metadata.tax"
              prepend-inner-icon="mdi-cash-fast"
              :items="taxes"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="12" class="pb-0">
            <v-textarea
              label="Remarks"
              placeholder="Enter Remarks"
              outlined
              dense
              hide-details
              :rows="2"
              v-model="service.remarks"
            ></v-textarea>
          </v-col>
          <v-col cols="12" class="pb-0" v-if="$root.onlyAccountsCanAccess">
            <v-textarea
              label="Accounts Remarks"
              placeholder="Enter Accounts Remarks"
              outlined
              background-color="light-blue lighten-5"
              dense
              hide-details
              :rows="2"
              v-model="service.accounts_remarks"
            class="accounts-remarks-field"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-col cols="12" class="pt-10">
          <v-btn color="primary" @click="addHotelService">Add</v-btn>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-btn class="float-right" color="success" outlined :disabled="loading" :loading="loading"
            @click="saveDetails">Save</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  import rules from '../../../../utilities/validator';
  import _find from 'lodash/find';

  export default {
    name: 's-services-opted-crew-change-service',
    props: {
      operation: {
        type: Object,
        default: {},
      },
      isDraft: {
        type: Boolean,
        default: false,
      },
      servicesOpted: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        loading: false,
        form: false,
        isDisabled: false,
        rules,
        hotelServices: [],
        hotelBookingDeparture: {
          service_catalog_id: null,
          card_id: null,
          amount: 0,
          bill_type: 'Hotel Booking Crew Sign Off',
          metadata: {
            arrange_by_owner: false,
            no_of_nights: 0,
            singleSharing: false,
            doubleSharing: false,
            tripleSharing: false,
            onlyMeal: false,
            no_of_single_sharing_crews: 0,
            no_of_double_sharing_crews: 0,
            no_of_triple_sharing_crews: 0,
            no_of_only_meal_crews: 0,
            tax: '',
            day_or_halfday_use: ""
          },
          remarks: '',
          accounts_remarks: '',
        },
        hotelBookingSuppliers: [],
        taxes: ['0%', '9%'],
        dayorhalf: ["Full Day", "Half Day"]
      };
    },
    methods: {
      removeHotelServiceEntry(index, serviceId) {
        if (!serviceId) {
          this.hotelServices.splice(index, 1);
          return;
        }
        this.loading = true;
        this.$api.operation_billed_items.remove_service_entry(serviceId, { index })
          .then(() => {
            const indexOfService = this.servicesOpted.findIndex(s => s.id === serviceId);
            if (indexOfService !== -1) {
              this.servicesOpted.splice(indexOfService, 1);
            }
            this.$store.dispatch('setAlert', {
              status: 'success',
              show: true,
              message: 'Service entry removed successfully',
            });
            this.hotelServices.splice(index, 1);
          })
          .catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      addHotelService() {
        const newHotelService = JSON.parse(JSON.stringify(this.hotelBookingDeparture));
        this.hotelServices.push(newHotelService);
      },
      submit() {
        return this.$refs.form.validate();
      },
      handleOperationInit() {
        this.populateSuppliers();
      },
      initServiceOptedDetails() {
        const hotelBookingDeparture = _.filter(this.servicesOpted, {bill_type: 'Hotel Booking Crew Sign Off'});

        if (hotelBookingDeparture.length) {
          const newServices = hotelBookingDeparture.filter(service => 
              service.card_id !== null || (service.card_id === null && service.id) || (service.card_id === null && service.metadata.arrange_by_owner === true)
            );
          if (newServices.length > 0) {
            this.hotelServices = newServices.map(service => {
              service.metadata.arrange_by_owner = service.metadata.arrange_by_owner || false;

              return {
                ...service,
                amount: service.amount ? parseFloat(service.amount).toFixed(2) : 0,
              };
            });
          } else {
            this.hotelServices = [JSON.parse(JSON.stringify(this.hotelBookingDeparture))];
          }
        } else {
          this.addHotelService();
        }
      },
      populateSuppliers() {
        this.$api.service_catalogs.get_suppliers_list('Hotel Booking Crew Sign Off')
          .then((response) => {
            this.hotelBookingSuppliers = response.suppliers;
            this.hotelBookingDeparture.service_catalog_id = response.service_catalog_id;
            this.initServiceOptedDetails();
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
      saveDetails() {
        if(!this.submit()) return;
        this.loading = true;
        this.hotelServices = this.hotelServices.map(service => {
          service.service_catalog_id = this.hotelBookingDeparture.service_catalog_id;
          service.operation_id = this.operation.id;

          return service;
        });

        Promise.all([
          ...[...this.hotelServices].map(service => {
            const apiType = service.id ? "update" : "save_service";
            return this.$api.operation_billed_items[apiType](service, true)
          })
        ]).then((response) => {
          response.forEach(service => {
            service = service.operation_billed_item;
            const indexOfService = this.servicesOpted.findIndex(s => s.id === service.id);
            if (indexOfService !== -1) {
              this.$set(this.servicesOpted, indexOfService, service);
            } else {
              this.servicesOpted.push(service);
            }
          });
          this.initServiceOptedDetails();
          this.$store.dispatch('setAlert', {
            status: 'success',
            show: true,
            message: 'Hotel Booking Crew Sign Off service updated successfully',
          });
        }).catch((err) => {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: err.message,
          });
        }).finally(() => (this.loading = false));
      }
    },
    computed: {
      amountRules() {
        return this.hotelServices.map(service => {
          if (service.metadata.arrange_by_owner) {
            return [this.rules.negative];
          } else {
            if (this.isDraft || (this.operation && this.operation.is_draft)) {
              return [this.rules.required, this.rules.negative];
            } else {
              return [this.rules.negative];
            }
          }
        });
      },
      supplierRules() {
        return this.hotelServices.map(service => {
          if (service.metadata.arrange_by_owner) {
            return [];
          } else {
            return [this.rules.required];
          }
        });
      }
    },
    watch: {
      operation(value) {
        this.handleOperationInit();
      },
    },
    created() {
      this.handleOperationInit();
    },
  };
</script>